/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */

import { DateTimeString, date } from 'common'
export type __FORCE_MODULE__ = unknown; //We add this line so that even if the file ends up being empty, it will still be recognized as a module without impacting the bundle size.

export class PersonNotificationConfig {
  notifications: Array<NotificationInfo> = [];
  icons: Array<IconsData> = [];
}

export class PersonNotification {
  notCfgGU?: string;
  notificationGU?: string;
  linkViewGU?: string;
  linkTabGU?: string;
  linkIdentity?: string;
  comment?: string;
  commentDetail?: string;
}

export class NotificationInfo {
  ID?: string;
  shortDescription?: string;
  description?: string;
  viewGU?: string;
  icon?: string;
  iconGU?: string;
  listOrder?: string;
  notificationType: NotificationTypeEnum = new NotificationTypeEnum;
  displayType: LU_PERSON_NOTE_DISPLAYTYPE_Enum = LU_PERSON_NOTE_DISPLAYTYPE_Enum.Icon;
  bannerColor?: string;
}

export class SessionConstants {
  disablePolling: boolean = false;
  impersonated: boolean = false;
}

export class RelatedBusinessObjectResponse {
  frequentlyUsed: Array<BusinessObjectInfo> = [];
  primary: Array<BusinessObjectInfo> = [];
  nonPrimary: Array<BusinessObjectInfo> = [];
}

export class BusinessObjectInfo {
  parentBOID?: string;
  boid?: string;
  name?: string;
  nameSpace?: string;
  queryDisplayType?: string;
  properties: Array<BOPropertyInfo> = [];
}

export class BOPropertyInfo {
  locked: boolean = false;
  ID?: string;
  srcElement?: string;
  boid?: string;
  type?: string;
  isFK: boolean = false;
  conditional: boolean = false;
  fieldType: BOFieldType = BOFieldType.Currency;
}

export class ExtractData {
  guid?: string;
  resultType?: string;
  companyID?: string;
  namespace?: string;
  locked: boolean = false;
  ID?: string;
  label?: string;
  primaryObject?: string;
  joinPropertyOverride?: string;
  joinPropertyOverrideChild?: string;
  joinToParentType?: string;
  blankRows?: number;
  detailType?: string;
  fullyQualifiedName?: string;
  details: Array<ExtractDataDetail> = [];
  items: Array<ExtractDataItem> = [];
}

export class DataSourceInfo {
  queryType?: string;
  query?: string;
}

export class UserPreferences {
  showBoInformation: boolean = false;
  lockQuickNav: boolean = false;
  showCompactView: boolean = false;
  pinFeedbackTab: boolean = false;
  showAllWidgets: boolean = false;
  showTasks: boolean = false;
  showAnnouncements: boolean = false;
  showWidgetType?: string;
  showFullHeader: boolean = false;
  showHighContrast: boolean = false;
  highContrastColor?: string;
  showFocusTree: boolean = false;
  classicNav: boolean = false;
  findGraphType?: string;
  findGraphPalette?: string;
  documentValidationLocation?: string;
  documentValidationPinned: boolean = false;
  docValWidth?: string;
  docValHeight?: string;
  graphCustomPalette: Array<string> = [];
  detachChooser: boolean = false;
  accessibilityMode: boolean = false;
  navigationMode: number = 0;
  ddSearchOption?: string;
  autosavePref: AutosaveOpt = AutosaveOpt.NoAutosave;
  loginResumePref: LoginResumeOpt = LoginResumeOpt.Never;
  designConfigMenuLocation?: string;
  navBmSortAlpha: boolean = false;
  navOnlyShowExpanded: boolean = false;
  widthNcBookmarks?: string;
  widthNcHistory?: string;
  widthNcPadTree?: string;
  widthNcNavigation?: string;
  feedbackTabLocation?: string;
  showSnapshot?: string;
  bookmarksIsPinned: boolean = false;
  historyIsPinned: boolean = false;
  navigationIsPinned: boolean = false;
  padTreeIsPinned: boolean = false;
  pinnedCategories: Array<string> = [];
  navNumColumns: number = 0;
  useAdvancedFkSearch: boolean = false;
  qnaShowAllRoles: boolean = false;
  modifierKeys?: string;
  showUserDock: boolean = false;
  collapseUserDock: boolean = false;
  useDefaultAutoFocus: boolean = false;
  dontPinGridHeaders: boolean = false;
  disableShelving?: string;
  colorTheme?: string;
  stColorTheme?: string;
  qnNumItemsToShow: number = 0;
  qnLayoutType?: string;
  notificationIconSize?: string;
  largeNotificationIcons: boolean = false;
  notificationsLocation?: string;
  canUpdateNotificationsLocation: boolean = false;
  qlEntityBO?: string;
  allowGridFilters: boolean = false;
  unpinnedTabPanel: boolean = false;
  gridDetailType?: string;
  vidConfCounter: number = 0;
  showReportDefaultsDD: boolean = false;
  lucidInterface: boolean = false;
  showLinkNav: boolean = false;
  showAllSuggestions: boolean = false;
  useCkEditor5: boolean = false;
  focusErrorType: FocusErrorViewType = FocusErrorViewType.None;
  yearRenderMode?: string;
  unpinFindResults: boolean = false;
  ctrlKActivations: number = 0;
  authAccessTokens: Record<string, STAccessToken> = {};
  customColors: Record<string, string> = {};
  checkListShowDismissed: boolean = false;
  checkListSelections?: string;
  checkListPreferences: Record<string, CheckListPreference> = {};
  qlEntityBoList: Array<string> = [];
  showDistrictTemplates: boolean = false;
  collapsedFilterGroups: Array<string> = [];
  focusFavorites: Array<FocusAccessInfo> = [];
}

export class ReportGroup {
  reportGroupDefGU?: string;
  reportPrefixes: Array<string> = [];
  description?: string;
  groupImage?: string;
  reports: Array<ReportInfoCard> = [];
}

export class ReportInfoCard {
  reportGU?: string;
  groupReportGU?: string;
  name?: string;
  number?: string;
  extractDataGU?: string;
  isDevExpress: boolean = false;
  reportPrefix?: string;
  reportGroupOverride?: string;
  reportOwnerGU?: string;
  reportPreviewImage?: string;
  canEdit: boolean = false;
  canCopy: boolean = false;
  canExport: boolean = false;
  noOutput: boolean = false;
  padPath?: string;
  originalReportGU?: string;
  parentReportGU?: string;
  parentReport?: string;
  isPublished: boolean = false;
}

export class ReportCreationResult {
  report: ReportInfoCard = new ReportInfoCard;
  warning?: string;
}

export class ReportBrowserSecurityInfo {
  canAdd: boolean = false;
  canEdit: boolean = false;
  canPublish: boolean = false;
  canAccessMyReports: boolean = false;
}

export class JobQueueRunInfo {
  processQueueGU?: string;
  submitDate?: string;
  imgBase64?: string;
}

export class ReportArchiveImportOptions {
  overwriteExisting: boolean = false;
  newReportName?: string;
  newReportNumber?: string;
}

export class CreateMessagePrompt {
  subject?: string;
  message?: string;
  writingStyleGU: any;
  styleName?: string;
  name?: string;
  tone: VoiceTone = VoiceTone.Casual;
  attitude: VoiceAttitude = VoiceAttitude.Neutral;
  verbosity: Verbosity = Verbosity.Concise;
  content?: string;
  instructions?: string;
  writingStyleInstructions?: string;
}

export class CollabCheckpoint {
  key?: string;
  columnHash?: string;
  snapshotBase64?: string;
  lastAccessed: DateTimeString = date.Empty;
}

export class CollabBootstrapRequest {
  key?: string;
  value?: string;
  snapshotBase64?: string;
}

export class CollaborativeEditBroadcastMessage {
  key?: string;
  messageBase64?: string;
  sourceClientId?: string;
  ID?: string;
  type?: string;
}

export class CursorInfo {
  name?: string;
  color?: string;
}

export class DataStoreProperty {
  srcName?: string;
  currentValue?: string;
  originalValue?: string;
}

export class DocumentScanResult {
  AAMVA: AAMVAInfo = new AAMVAInfo;
  photoBase64?: string;
  idBase64?: string;
}

export class ViewState {
  viewGU?: string;
  tabGU?: string;
  identity?: string;
  serverState: Record<string, string> = {};
  dataElements: Array<DataElement> = [];
  gridElements: Array<GridElement> = [];
}

export class LookupValuePair {
  value?: string;
  description?: string;
  displayValue?: string;
}

export class FocusInfo {
  focusKey?: string;
  focusOrgYearGU?: string;
  orgYears: Array<OrgYearInfo> = [];
}

export class LookupItem {
  code?: string;
  desc?: string;
}

export class WritingStylePrompt {
  writingStyleGU: any;
  styleName?: string;
  name?: string;
  tone: VoiceTone = VoiceTone.Casual;
  attitude: VoiceAttitude = VoiceAttitude.Neutral;
  verbosity: Verbosity = Verbosity.Concise;
  content?: string;
  instructions?: string;
  writingStyleInstructions?: string;
  message?: string;
}

export class ViewGridDef {
  guid?: string;
  title?: string;
  primaryObjectGU?: string;
  showLineSelector: boolean = false;
  supertitles: Record<string, GridSupertitleDef> = {};
  columns: Array<GridColumnDef> = [];
}

export class GridData {
  rows: Array<GridRowData> = [];
  startRow: number = 0;
  totalRows: number = 0;
  duration: number = 0;
}

export class QueueReportResponse {
  success: boolean = false;
  jobQueueGUID?: string;
  errorMessage?: string;
}

export class JobQueueEntryOptions {
}

export class JobQueueStatusInfo {
  processQueueGU?: string;
  jobID?: string;
  state: JobState = JobState.Hold;
  type?: string;
  category?: string;
  userJobStatus?: string;
  description?: string;
  note?: string;
  primaryResultFile?: string;
  hasAction: boolean = false;
  hasResultFile: boolean = false;
  multiResultFile: boolean = false;
  completionDT?: string;
  forceDownloadPrompt: boolean = false;
  htmlImageName?: string;
  stateDescription?: string;
  progress?: string;
  progressMessage?: string;
  statusIcon?: string;
  jobTypeIcon?: string;
  recurring: boolean = false;
  resultType: ReportExportFilterType = ReportExportFilterType.PDF;
  resultMessage?: string;
  submitDT?: string;
  reportGU?: string;
  focusKey?: string;
}

export class JobQueueStatusListResponse {
  userViewerAccess: boolean = false;
  adminViewerAccess: boolean = false;
  jobs: Array<JobQueueStatusInfo> = [];
}

export class QueryPreview {
  stQueryString?: string;
  rawResponse?: string;
  primaryBO: PreviewBO = new PreviewBO;
  aiLogGU?: string;
}

export class QueryAssistReference {
  s3Uri?: string;
  content?: string;
}

export class QueryResult {
  columnMetadata: Array<ColumnMetadata> = [];
  rows: Array<Record<string, string>> = [];
  sqlStatement?: string;
  errorMessage?: string;
}

export class Recur {
  onlyScheduleForValidDays: boolean = false;
  endTimeDaily: DateTimeString = date.Empty;
  everyHour: number = 0;
  everyMinute: number = 0;
  startTime: DateTimeString = date.Empty;
  startDate: DateTimeString = date.Empty;
  stopDate: DateTimeString = date.Empty;
  type: RecurType = RecurType.Once;
  dayCount: number = 0;
  weekCount: number = 0;
  monday: boolean = false;
  tuesday: boolean = false;
  wednesday: boolean = false;
  thursday: boolean = false;
  friday: boolean = false;
  saturday: boolean = false;
  sunday: boolean = false;
  monthType: MonthlyType = MonthlyType.DaySpecific;
  monthDayofMonth: number = 0;
  monthDayType: MonthlyDayType = MonthlyDayType.First;
  monthDayofWeek: MonthDayofWeek = MonthDayofWeek.Sunday;
  january: boolean = false;
  february: boolean = false;
  march: boolean = false;
  april: boolean = false;
  may: boolean = false;
  june: boolean = false;
  july: boolean = false;
  august: boolean = false;
  september: boolean = false;
  october: boolean = false;
  november: boolean = false;
  december: boolean = false;
}

export class ReportOutput {
  header: ReportOutputHeader = new ReportOutputHeader;
  dataDef: ReportOutputDataDef = new ReportOutputDataDef;
  dataRoot: ReportOutputDataRoot = new ReportOutputDataRoot;
}

export class FieldRoleHint {
  priority: number = 0;
  name?: string;
  role: FieldRole = FieldRole.RowOrColumn;
}

export class CalendarInfo {
  calendar: Array<CalendarDateInfo> = [];
  legends: Array<CalendarLegendInfo> = [];
}

export class AppointmentData {
  appointments: Array<AppointmentInfo> = [];
  calendar: Array<CalendarDateInfo> = [];
}

export class ConversationOverview {
  conversationGU?: string;
  title?: string;
  timestamp: DateTimeString = date.Empty;
  isArchived: boolean = false;
  ticketGU?: string;
}

export class Conversation {
  conversationGU?: string;
  title?: string;
  timestamp: DateTimeString = date.Empty;
  messages: Array<Message> = [];
  isArchived: boolean = false;
  ticketGU?: string;
}

export class StreamingEnvelope {
  type?: string;
  data?: string;
}

export class TicketEmailDraft {
  ticketGU?: string;
  ticketNumber?: string;
  ticketTitle?: string;
  clientEmail?: string;
  clientUserGU?: string;
  subject?: string;
  body?: string;
  bodyHtml?: string;
  to: Array<EmailRecipient> = [];
  bcc: Array<EmailRecipient> = [];
}

export class EmailRecipient {
  userGU?: string;
  name?: string;
  email?: string;
  isEdupointStaff: boolean = false;
}

export class SupportResponse {
  aiLogGU?: string;
  text?: string;
  citations: Array<ResponseCitation> = [];
}

export class ViewDef {
  componentName?: string;
  guid?: string;
  qualifiedViewName?: string;
  title?: string;
  panel: ViewPanel = new ViewPanel;
  tabs: Array<ViewTab> = [];
}

export class ViewDefinition {
  allowChangeFocus: boolean = false;
  allowPropertySearch: boolean = false;
  autoAddReports: boolean = false;
  cachable: boolean = false;
  company?: string;
  deleteConfirmation: DeleteConfirmation = DeleteConfirmation.BasicConfirmation;
  disableAuditMenu: boolean = false;
  disableSecurity: boolean = false;
  dontRefreshParentOnClose: boolean = false;
  enforceMandatory: boolean = false;
  helpID?: string;
  icon?: string;
  loadDataImmediately: boolean = false;
  namespace?: string;
  organizationType: OrganizationType = OrganizationType.Default;
  primaryObject?: string;
  shortTitle?: string;
  title?: string;
  type: ViewType = ViewType.DataEntry;
  useType: UseType = UseType.Other;
  wizardViewID?: string;
  companyID?: string;
  noCloseOnSelect: boolean = false;
  enableTemplates: boolean = false;
  minimumWidth?: string;
  modal: boolean = false;
  windowHeight?: string;
  windowHorizontalPosition: HorizontalPosition = HorizontalPosition.Center;
  windowVerticalPosition: VerticalPosition = VerticalPosition.Center;
  windowWidth?: string;
  associatedViewID?: string;
  localization?: string;
  module?: string;
  number?: string;
  afterDelete: boolean = false;
  afterFindMode: boolean = false;
  afterInsert: boolean = false;
  afterUpdate: boolean = false;
  afterRawXML: boolean = false;
  afterRead: boolean = false;
  afterRender: boolean = false;
  afterUndo: boolean = false;
  beforeDelete: boolean = false;
  beforeFind: boolean = false;
  beforeFkRender: boolean = false;
  beforeInsert: boolean = false;
  beforeRead: boolean = false;
  beforeRender: boolean = false;
  beforeUndo: boolean = false;
  beforeUpdate: boolean = false;
  externalObjSelAdd: boolean = false;
  fkFilter: boolean = false;
  postRoundTripInATransaction: boolean = false;
  postRoundTripOutOfATransaction: boolean = false;
  uiObject?: string;
  aspxPage?: string;
  deprecated: boolean = false;
  actionMappings: Array<string> = [];
  actionArea: ActionAreaDefinition = new ActionAreaDefinition;
  titleArea: TitleAreaDefinition = new TitleAreaDefinition;
  tabGroup: TabGroupDefinition = new TabGroupDefinition;
  dataArea: DataAreaDefinition = new DataAreaDefinition;
  sortPropertyGroup: SortPropertyGroupDefinition = new SortPropertyGroupDefinition;
  controls: Array<IViewChild> = [];
  ID?: string;
  alias?: string;
  disableLink: boolean = false;
  binding: DataBinding = new DataBinding;
  dataAllowWrap: boolean = false;
  labelAllowWrap: boolean = false;
  neverDisable: boolean = false;
  visible: boolean = false;
  label?: string;
  indicator: IndicatorInfo = new IndicatorInfo;
  linkOptions: LinkOptions = new LinkOptions;
}

export class ViewData {
}

export class ViewDataLoadOptions {
}

export class RevResponse {
  REV_RETURN: RevReturn = new RevReturn;
  REV_DATA_ROOT: RevDataRoot = new RevDataRoot;
}

export class VerificationResult {
  passed: boolean = false;
  message?: string;
  matchingOffenders: Array<SexOffender> = [];
}

export class VisitorAddRequest {
  vmVisitorGU?: string;
  cellPhone?: string;
  checkInDatetime?: string;
  checkInReason?: string;
  dateOfBirth?: string;
  dlOrIdNumber?: string;
  email?: string;
  firstName?: string;
  idImageBase64?: string;
  lastName?: string;
  notes?: string;
  photoBase64?: string;
  visitorType?: string;
  meetingWith?: string;
}

export class InitialScanResposne {
  status?: string;
  errorCode?: string;
  activeCheckin: ActiveCheckinInfo = new ActiveCheckinInfo;
  repeatTier?: string;
  repeatPriorVisit: RepeatPriorVisit = new RepeatPriorVisit;
}

export class ManualEntryData {
  firstName?: string;
  lastName?: string;
  dateOfBirth: DateTimeString = date.Empty;
  idType?: string;
  idNumber?: string;
  photoBase64?: string;
  idBase64?: string;
}

export class DenyVisitorResponse {
  message?: string;
}

export class CompleteCheckinRequest {
  visitorGU?: string;
  cellPhone?: string;
  email?: string;
  visitorType?: string;
  notes?: string;
  meetingWith?: string;
  checkInReason?: string;
  vmStationGU?: string;
}

export class StationRegistrationResult {
  isRegistered: boolean = false;
  vmStationGU?: string;
  stationName?: string;
}

export class OrganizationSearchResult {
  organizationGU?: string;
  organizationName?: string;
}

export class SynergyConnectMetadata {
  BGDL?: string;
  GGDL?: string;
  vmAudioBad?: string;
  vmAudioGood?: string;
}

export class StaffSearchResult {
  staffGU?: string;
  formattedName?: string;
}

export class BlockedVisitorResult {
  tier?: string;
  message?: string;
  matches: Array<BlockedVisitorMatchDto> = [];
}

export class PrintData {
  visitorType?: string;
  firstName?: string;
  lastName?: string;
  visitorGU?: string;
  meetingWith?: string;
  checkInDateTime?: string;
  reason?: string;
  photoBase64?: string;
}

export class ViewFilterOptions {
  filters: Array<UserFilterObj> = [];
  sharedFilters: Array<SharedUserFilterObj> = [];
  collections: Array<RevCollectionData> = [];
  groups: Array<UserFilterGroupInfo> = [];
  collapsedGroups: Array<string> = [];
  checkListPreferences: Record<string, CheckListPreference> = {};
}

export class CheckListPreference {
  collectionGU?: string;
  showFilters: boolean = false;
  showDismissed: boolean = false;
  showDetails: boolean = false;
  userFilterCollectionGU?: string;
  hiddenFields: Array<number> = [];
}

export class RevCollectionData {
  collectionGU?: string;
  name?: string;
  description?: string;
  objectID?: string;
  creationDate?: string;
  sharedMsg?: string;
  hasXmlRequest: boolean = false;
  reportResults: Array<ReportResult> = [];
  identities: Array<string> = [];
}

export class UserFilterObj {
  primaryGU?: string;
  filterGU?: string;
  name?: string;
  enabled: boolean = false;
  order: number = 0;
  userFilterGU?: string;
  filterGroupGU?: string;
  filterGroup: UserFilterGroupInfo = new UserFilterGroupInfo;
  filterCondGroups: Array<UserFilterObjGroup> = [];
  primaryBOID?: string;
}

export class UserFilterGroupInfo {
  filterGroupGU?: string;
  groupName?: string;
  iconPath?: string;
  parentGroupGU?: string;
  order: number = 0;
}

export class STQuery {
  primaryBO: STQueryBO = new STQueryBO;
  conditionContainer: STQueryConditionContainer = new STQueryConditionContainer;
  sorts: Array<STQuerySort> = [];
  properties: Array<STQueryBOProperty> = [];
}

export class SchemaNode {
  nodeType: STNodeType = STNodeType.Property;
  name?: string;
  nodes: Array<SchemaNode> = [];
  hidden: boolean = false;
  originalName?: string;
  labelOverride?: string;
  width?: number;
  groupLevel?: number;
  break: PageBreak = PageBreak.None;
  fieldType?: string;
}

export class SynergyQueryValidationResult {
  isValid: boolean = false;
  originalQuery?: string;
  formattedQuery?: string;
}

export class GetStaffAttendanceDataResponse {
  attendanceType: SchoolAttTypeEnum = SchoolAttTypeEnum.Daily;
  staffSchoolYearGU?: string;
  isValidSchoolWeek: boolean = false;
  staffSectionData: Array<StaffSectionData> = [];
}

export class GetStaffAttendanceDataRequest {
  startDate?: string;
  endDate?: string;
}

export class SaveSectionConfirmationResponse {
  success: boolean = false;
  errorMessage?: string;
  staffAttendanceVerifyGU?: string;
}

export class SaveSectionConfirmationRequest {
  staffSchoolYearGU?: string;
  startDate?: string;
  endDate?: string;
  sectionGU?: string;
  status: StatusVerification = StatusVerification.None;
}

export class SaveSignatureResponse {
  signatureGU?: string;
  staffAttendanceVerifyGU?: string;
  success: boolean = false;
  errorMessage?: string;
}

export class SaveSignatureRequest {
  signatureBase64?: string;
  personGU?: string;
  staffSchoolYearGU?: string;
  startDate?: string;
  endDate?: string;
  sectionVerifications: Array<SectionVerificationData> = [];
  declined?: boolean;
  declinedReason?: string;
  response?: string;
  existingSignatureGU?: string;
}

export class GetAttendanceCodesResponse {
  success: boolean = false;
  errorMessage?: string;
  attendanceCodes: Array<AttendanceCodeInfo> = [];
}

export class CheckAttendanceVerificationResponse {
  success: boolean = false;
  errorMessage?: string;
  hasVerification: boolean = false;
  hasDocument: boolean = false;
  isPending: boolean = false;
  staffAttendanceVerifyGU?: string;
  personAtcDocGU?: string;
  status?: string;
  sectionVerifications: Array<SectionVerificationData> = [];
}

export class CheckAttendanceVerificationRequest {
  startDate?: string;
  endDate?: string;
}

export class CancelPendingVerificationResponse {
  success: boolean = false;
  errorMessage?: string;
}

export class CancelPendingVerificationRequest {
  startDate?: string;
  endDate?: string;
}

export class CheckExistingSignatureResponse {
  success: boolean = false;
  errorMessage?: string;
  hasSignature: boolean = false;
  signatureGU?: string;
}

export class DownloadAttendanceDocumentResponse {
  success: boolean = false;
  errorMessage?: string;
  fileVirtualPath?: string;
  filePhysicalPath?: string;
  fileName?: string;
}

export class DownloadAttendanceDocumentRequest {
  personAtcDocGU?: string;
}

export class SaveAttendanceVerificationDocumentResponse {
  personAtcDocGU?: string;
  success: boolean = false;
  errorMessage?: string;
}

export class SaveAttendanceVerificationDocumentRequest {
  staffAttendanceVerifyGU?: string;
  jobQueueGU?: string;
  staffGU?: string;
  startDate?: string;
  endDate?: string;
  docCategory?: string;
}

export class GetDocumentCategoriesResponse {
  success: boolean = false;
  errorMessage?: string;
  categories: Array<DocumentCategoryOption> = [];
  savedDocCategory?: string;
}

export class IconsData {
  iconGU?: string;
  iconName?: string;
  iconFilePath?: string;
}

export class NotificationTypeEnum {
}

export enum LU_PERSON_NOTE_DISPLAYTYPE_Enum {
  Icon = 0,
  Banner = 1,
  IconAndBanner = 2,
}

export enum BOFieldType {
  Currency = 0,
  Date = 1,
  Numeric = 2,
  Phone = 3,
  SSN = 4,
  String = 5,
  Memo = 6,
  Lookup = 7,
  Image = 8,
  GUID = 9,
  DateTime = 10,
}

export class ExtractDataDetail {
  locked: boolean = false;
  ID?: string;
  label?: string;
  primaryObject?: string;
  joinPropertyOverride?: string;
  joinPropertyOverrideChild?: string;
  joinToParentType?: string;
  blankRows?: number;
  detailType?: string;
  fullyQualifiedName?: string;
  details: Array<ExtractDataDetail> = [];
  items: Array<ExtractDataItem> = [];
}

export class ExtractDataItem {
  ID?: string;
  srcElement?: string;
  srcObject?: string;
  type?: string;
  lookupDisplay?: string;
  alias?: string;
  label?: string;
  order: number = 0;
  visible: boolean = false;
  labelWrap: boolean = false;
  neverDisable: boolean = false;
  showAllOptions: boolean = false;
  textMode?: string;
  columns: number = 0;
  guid?: string;
  orientation?: string;
  showTitle: boolean = false;
  locked: boolean = false;
}

export enum AutosaveOpt {
  NoAutosave = 0,
  AlwaysPrompt = 1,
  Autosave = 2,
}

export enum LoginResumeOpt {
  Never = 0,
  Prompt = 1,
  Always = 2,
}

export enum FocusErrorViewType {
  None = 0,
  LastVisited = 1,
  Home = 2,
  Invalid = 3,
}

export class STAccessToken {
  accessToken?: string;
  refreshToken?: string;
  tokenType?: string;
  expiresIn?: string;
  scope?: string;
}

export class FocusAccessInfo {
  focusYearTitle?: string;
  active: ShowActiveInactiveEnum = ShowActiveInactiveEnum.ActiveOnly;
  focusOrganizationGU?: string;
  focusOrganizationName?: string;
  focusYearGU?: string;
  focusSchoolYear?: string;
  timestamp?: string;
}

export class GeneratedText {
  hint?: string;
  text?: string;
}

export enum VoiceTone {
  Casual = 0,
  Technical = 1,
  Formal = 2,
}

export enum VoiceAttitude {
  Neutral = 0,
  Empathetic = 1,
  Enthusiastic = 2,
  Persuasive = 3,
}

export enum Verbosity {
  Concise = 0,
  Brief = 1,
  Comprehensive = 2,
  Verbose = 3,
}

export class AAMVAInfo {
  additionalJurisdictionElements: Record<string, string> = {};
  city?: string;
  country?: string;
  state?: string;
  zip?: string;
  street1?: string;
  street2?: string;
  dateOfBirth: DateTimeString = date.Empty;
  documentDiscriminator?: string;
  ethnicity?: string;
  expirationDate: DateTimeString = date.Empty;
  eyeColor?: string;
  hairColor?: string;
  heightInches: number = 0;
  idNumber?: string;
  inventoryControlNumber?: string;
  isOrganDonor: boolean = false;
  issueDate: DateTimeString = date.Empty;
  issuerIdentificationNumber?: string;
  endorsementCodeDescription?: string;
  endorsementCodes?: string;
  restrictionCodeDescription?: string;
  restrictionCodes?: string;
  vehicleClass?: string;
  vehicleClassificationDescription?: string;
  aliasFirst?: string;
  aliasLast?: string;
  aliasSuffix?: string;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  suffix?: string;
  placeOfBirth?: string;
  revisionDate: DateTimeString = date.Empty;
  sex?: string;
  weightPounds: number = 0;
}

export class DataElement {
  srcName?: string;
  value?: string;
  originalValue?: string;
  soundexSearch: boolean = false;
  ignoreDirectFind: boolean = false;
  condition: ElementCondition = new ElementCondition;
}

export class GridElement {
  guid?: string;
  dataElements: Array<DataElement> = [];
}

export class OrgYearInfo {
  organization: OrgInfo = new OrgInfo;
  year: YearInfo = new YearInfo;
  children: Array<OrgYearInfo> = [];
  orgYearGU?: string;
  organizationName?: string;
  edFiDistrictId?: string;
  edFiKey?: string;
  edFiAltKey?: string;
  organizationGU?: string;
  parentOrganizationGU?: string;
  schoolYear?: string;
  yearGU?: string;
  extension?: string;
  fullYear?: string;
  fullYearVerbose?: string;
  isLeaf: boolean = false;
}

export class GridGeneratedText {
  text: Array<string> = [];
}

export class GridSupertitleDef {
  guid?: string;
  label?: string;
  supertitle?: string;
  colSpan: number = 0;
  rowSpan: number = 0;
}

export class GridColumnDef {
  label?: string;
  controlType?: string;
  supertitles: Array<string> = [];
  rowSpan: number = 0;
}

export class GridRowData {
  identity?: string;
  values: Array<string> = [];
}

export class IACData {
  reports: Array<IntegratedActionItem> = [];
  processes: Array<IntegratedActionItem> = [];
}

export enum JobState {
  Hold = 0,
  Waiting = 1,
  InProgress = 2,
  Error = 3,
  Complete = 4,
  Canceling = 5,
  Deleted = 6,
  AbnormallyAborted = 7,
  CtlInProgress = 8,
}

export enum ReportExportFilterType {
  PDF = 0,
  HTML = 1,
  Excel = 2,
  TIFF = 3,
  RTF = 4,
  Txt = 5,
  XML = 6,
  DBF = 7,
  CSV = 8,
  Fixed = 9,
  ZIP = 10,
  ExcelXLSX = 11,
  WordDOCX = 12,
  Action = 13,
  Interactive = 14,
}

export class PreviewBO {
  alias?: string;
  BOID?: string;
  ID?: string;
  joinDestinationAlias?: string;
  joinDestinationID?: string;
  joinDestinationProperty?: string;
  joinDestinationPropertyOrig?: string;
  joinSourceAlias?: string;
  joinSourceProperty?: string;
  joinSourcePropertyOrig?: string;
  joinType: QBBOJoinType = QBBOJoinType.Default;
  name?: string;
  nameOriginal?: string;
  nameSpace?: string;
  childBOs: Array<PreviewBO> = [];
  properties: Array<PreviewProperty> = [];
}

export class ColumnMetadata {
  columnName?: string;
  columnLabel?: string;
  order: number = 0;
  isScrollProperty: boolean = false;
  isPhoto: boolean = false;
}

export enum RecurType {
  Once = 0,
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  Custom = 4,
}

export enum MonthlyType {
  DaySpecific = 0,
  DayPattern = 1,
}

export enum MonthlyDayType {
  First = 1,
  Second = 2,
  Third = 3,
  Fourth = 4,
  Last = 5,
}

export enum MonthDayofWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export class ReportOutputHeader {
  name?: string;
  number?: string;
  guid?: string;
  orientation?: string;
  organization?: string;
  year?: string;
  yearType?: string;
  yearTitle?: string;
  orgPhone?: string;
  orgAbbrName?: string;
  orgAddress?: string;
  orgAddress2?: string;
  orgCity?: string;
  orgState?: string;
  orgZipcode?: string;
  orgFmtCyStZc?: string;
  revOrgAddress?: string;
  revOrgAddress2?: string;
  revOrgCity?: string;
  revOrgState?: string;
  revOrgZipcode?: string;
  revOrgFmtCyStZc?: string;
  revOrgEmail?: string;
  revOrgFax?: string;
  revOrgWebsite?: string;
  rootOrganization?: string;
  rootOrgPhone?: string;
  rootOrgAbbrName?: string;
  rootOrgAddress?: string;
  rootOrgAddress2?: string;
  rootOrgCity?: string;
  rootOrgState?: string;
  rootOrgZipcode?: string;
  rootOrgFmtCyStZc?: string;
  rootRevOrgAddress?: string;
  rootRevOrgAddress2?: string;
  rootRevOrgCity?: string;
  rootRevOrgState?: string;
  rootRevOrgZipcode?: string;
  rootRevOrgEmail?: string;
  rootRevOrgFax?: string;
  rootRevOrgWebsite?: string;
  rootRevOrgFmtCyStZc?: string;
  rootOrganizationLogo?: string;
  organizationLogo?: string;
  rootOrganizationWatermark?: string;
  organizationWatermark?: string;
  userName?: string;
  printedBy?: string;
  created?: string;
}

export class ReportOutputDataDef {
  labelGroup: Array<ReportOutputLabel> = [];
}

export class ReportOutputDataRoot {
  date?: string;
  time?: string;
  data: Array<any> = [];
}

export enum FieldRole {
  RowOrColumn = 0,
  Data = 1,
}

export class CalendarDateInfo {
  startDate?: string;
  endDate?: string;
  tooltip?: string;
  icon?: string;
  status: DateStatus = DateStatus.Active;
}

export class CalendarLegendInfo {
  title?: string;
  items: Array<CalendarLegendItem> = [];
}

export class AppointmentInfo {
  ID?: string;
  title?: string;
  subTitle?: string;
  description?: string;
  viewID?: string;
  category?: string;
  iconPath?: string;
  icon: GlyphIcon = GlyphIcon.None;
  colorIndex: number = 0;
  start: DateTimeString = date.Empty;
  end: DateTimeString = date.Empty;
}

export class Message {
  messageGU?: string;
  conversationGU?: string;
  timestamp: DateTimeString = date.Empty;
  role: MessageRole = MessageRole.System;
  text?: string;
  rating: UserRating = UserRating.None;
  traces: Array<Trace> = [];
}

export class ResponseCitation {
  start: number = 0;
  end: number = 0;
  text?: string;
  references: Array<ResponseCitationReference> = [];
}

export class ViewPanel {
  componentName?: string;
  controls: Array<IControl> = [];
}

export class ViewTab {
  componentName?: string;
  controls: Array<IControl> = [];
  guid?: string;
  label?: string;
}

export enum DeleteConfirmation {
  BasicConfirmation = 0,
  ButtonConfirmation = 1,
  DataEntryConfirmation = 2,
}

export enum OrganizationType {
  Default = 0,
  OrgYearAware = 1,
  OrgYearQualified = 2,
}

export enum ViewType {
  DataEntry = 0,
  Dialog = 1,
  NonData = 2,
  PassThroughAspx = 3,
  ExternalObjectSelection = 4,
  JobQueue = 5,
  Snapshot = 6,
  Wizard = 7,
  ScanInterface = 8,
  ReportView = 9,
  FKSelect = 10,
  PXP = 11,
  PXPEditable = 12,
  TXP = 13,
  TXPEditable = 14,
  JobQueueExecute = 15,
  Query = 16,
  FocusChange = 17,
  DocumentValidation = 18,
}

export enum UseType {
  Other = 0,
  SingleObject = 1,
  MultiObject = 2,
  Both = 3,
}

export enum HorizontalPosition {
  Center = 0,
  Left = 1,
  Right = 2,
}

export enum VerticalPosition {
  Center = 0,
  Bottom = 1,
  Top = 2,
}

export class ActionAreaDefinition {
  controls: Array<IActionAreaChild> = [];
  menu: MenuDefinition = new MenuDefinition;
  status: ViewStatusDefinition = new ViewStatusDefinition;
  ID?: string;
  alias?: string;
  disableLink: boolean = false;
  binding: DataBinding = new DataBinding;
  dataAllowWrap: boolean = false;
  labelAllowWrap: boolean = false;
  neverDisable: boolean = false;
  visible: boolean = false;
  label?: string;
  indicator: IndicatorInfo = new IndicatorInfo;
  linkOptions: LinkOptions = new LinkOptions;
}

export class TitleAreaDefinition {
  controls: Array<ITitleAreaChild> = [];
  ID?: string;
  alias?: string;
  disableLink: boolean = false;
  binding: DataBinding = new DataBinding;
  dataAllowWrap: boolean = false;
  labelAllowWrap: boolean = false;
  neverDisable: boolean = false;
  visible: boolean = false;
  label?: string;
  indicator: IndicatorInfo = new IndicatorInfo;
  linkOptions: LinkOptions = new LinkOptions;
}

export class TabGroupDefinition {
  panel: PanelDefinition = new PanelDefinition;
  tabs: Array<TabDefinition> = [];
  ID?: string;
  alias?: string;
  disableLink: boolean = false;
  binding: DataBinding = new DataBinding;
  dataAllowWrap: boolean = false;
  labelAllowWrap: boolean = false;
  neverDisable: boolean = false;
  visible: boolean = false;
  label?: string;
  indicator: IndicatorInfo = new IndicatorInfo;
  linkOptions: LinkOptions = new LinkOptions;
}

export class DataAreaDefinition {
  controls: Array<IDataAreaChild> = [];
  ID?: string;
  alias?: string;
  disableLink: boolean = false;
  binding: DataBinding = new DataBinding;
  dataAllowWrap: boolean = false;
  labelAllowWrap: boolean = false;
  neverDisable: boolean = false;
  visible: boolean = false;
  label?: string;
  indicator: IndicatorInfo = new IndicatorInfo;
  linkOptions: LinkOptions = new LinkOptions;
}

export class SortPropertyGroupDefinition {
  sortProperties: Array<SortPropertyDefinition> = [];
  ID?: string;
  alias?: string;
  disableLink: boolean = false;
  binding: DataBinding = new DataBinding;
  dataAllowWrap: boolean = false;
  labelAllowWrap: boolean = false;
  neverDisable: boolean = false;
  visible: boolean = false;
  label?: string;
  indicator: IndicatorInfo = new IndicatorInfo;
  linkOptions: LinkOptions = new LinkOptions;
}

export class IViewChild {
}

export class DataBinding {
  sourceObject?: string;
  sourceElement?: string;
  relationPath: RelationPath = new RelationPath;
}

export class IndicatorInfo {
  type: IndicatorType = IndicatorType.None;
  style: PropertyStyle = PropertyStyle.None;
  message?: string;
}

export class LinkOptions {
  dynamicComplexObjectAlias?: string;
  dynamicComplexIdentityAlias?: string;
  dynamicFieldSrcNameAlias?: string;
  dynamicFocusOrganizationGuAlias?: string;
  dynamicFocusOrganizationYearGuAlias?: string;
  dynamicFocusYearGuAlias?: string;
  dynamicIdentityAlias?: string;
  dynamicPropertyAlias?: string;
  dynamicReportAlias?: string;
  dynamicTabIdAlias?: string;
  hideSelectionArrow: boolean = false;
  openAsModal: boolean = false;
  sharedWindowName?: string;
  staticObjectID?: string;
  staticObjectTabID?: string;
  staticObjectComplexObjectID?: string;
}

export class RevReturn {
  RESULT?: string;
  ERROR: Array<Error> = [];
}

export class RevDataRoot {
  clientActions: Array<JSONClientAction> = [];
  REV_DATA_GROUP: RevDataGroup = new RevDataGroup;
  REV_VIEW: RevView = new RevView;
}

export class SexOffender {
  name?: string;
  firstName?: string;
  lastName?: string;
  aliases: Array<string> = [];
  dob?: string;
  address?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  locations: Array<string> = [];
  sex?: string;
  age?: string;
  eyeColor?: string;
  hairColor?: string;
  height?: string;
  weight?: string;
  race?: string;
  ethnicity?: string;
  marks?: string;
  riskLevel?: string;
  crime?: string;
  registrationDate?: string;
  content?: string;
  offenderUrl?: string;
  offenderImageUrl?: string;
  lat: number = 0;
  lng: number = 0;
  updatedAt?: string;
  isAbsconder?: boolean;
  jurisdiction?: string;
}

export class ActiveCheckinInfo {
  vmVisitorGU?: string;
  firstName?: string;
  lastName?: string;
  checkInDatetime?: string;
}

export class RepeatPriorVisit {
  vmVisitorGU?: string;
  visitorType?: string;
  checkInReason?: string;
  meetingWith?: string;
  meetingWithName?: string;
  firstName?: string;
  lastName?: string;
}

export class BlockedVisitorMatchDto {
  vmBlockedVisitorGU?: string;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  reasonCode?: string;
  reasonDescription?: string;
  notes?: string;
  tier?: string;
  disposition?: string;
  color?: string;
}

export class SharedUserFilterObj {
  fromUser?: string;
  primaryGU?: string;
  filterGU?: string;
  name?: string;
  enabled: boolean = false;
  order: number = 0;
  userFilterGU?: string;
  filterGroupGU?: string;
  filterGroup: UserFilterGroupInfo = new UserFilterGroupInfo;
  filterCondGroups: Array<UserFilterObjGroup> = [];
  primaryBOID?: string;
}

export class ReportResult {
  collRptResultGU?: string;
  label?: string;
}

export class UserFilterObjGroup {
  groupType?: string;
  userFilterCondition: Array<UserFilterObjCondition> = [];
  userFilterObjectGroups: Array<UserFilterObjGroup> = [];
  primaryBOID?: string;
}

export class STQueryBO {
  BOID?: string;
  name?: string;
  alias?: string;
  join: STQueryJoinInfo = new STQueryJoinInfo;
  children: Array<STQueryBO> = [];
}

export class STQueryConditionContainer {
  containerType: QBConditionContainerType = QBConditionContainerType.And;
  conditions: Array<STQueryCondition> = [];
  containers: Array<STQueryConditionContainer> = [];
}

export class STQuerySort {
  property: BOPropertyReference = new BOPropertyReference;
  sortType: QBSortType = QBSortType.Ascending;
}

export class STQueryBOProperty {
  graph: boolean = false;
  name: BOPropertyReference = new BOPropertyReference;
  labelOverride?: string;
  width?: string;
  hide: boolean = false;
  displayType: QBDisplayType = QBDisplayType.Default;
  altCodeType: QBAltCodeType = QBAltCodeType.None;
  group?: string;
  aggregateType: ColumnAggregateType = ColumnAggregateType.None;
  break: QBBreakType = QBBreakType.None;
  order: number = 0;
}

export enum STNodeType {
  Property = 0,
  Object = 1,
  Array = 2,
}

export enum PageBreak {
  None = 0,
  OnGroup = 1,
  OnPage = 2,
}

export enum SchoolAttTypeEnum {
  Daily = 0,
  Period = 1,
  Both = 2,
}

export class StaffSectionData {
  sectionGU?: string;
  sectionName?: string;
  trackGU?: string;
  validAttendanceWeek: boolean = false;
  periodNumber?: string;
  courseID?: string;
  courseName?: string;
  status: StatusVerification = StatusVerification.None;
  denyReason?: string;
  studentSectionData: Array<StudentSectionData> = [];
}

export enum StatusVerification {
  None = 0,
  Accepted = 1,
  Denied = 2,
}

export class SectionVerificationData {
  sectionGU?: string;
  status: StatusVerification = StatusVerification.None;
  denyReason?: string;
}

export class AttendanceCodeInfo {
  code?: string;
  description?: string;
  reasonType?: string;
  iconPath?: string;
  iconClass?: string;
  color?: string;
}

export class DocumentCategoryOption {
  value?: string;
  description?: string;
}

export enum ShowActiveInactiveEnum {
  ActiveOnly = 0,
  InactiveOnly = 1,
  ActiveAndInactive = 2,
}

export class ElementCondition {
  type?: string;
  values: Array<string> = [];
}

export class OrgInfo {
  parentGU?: string;
  organizationGU?: string;
  organizationYearGU?: string;
  organizationName?: string;
  isLeaf: boolean = false;
  isRoot: boolean = false;
  phone?: string;
  phone2?: string;
  defaultEmail?: string;
  childOrganizations: Array<OrgInfo> = [];
  edFiDistrictId?: string;
  edFiKey?: string;
  edFiAltKey?: string;
  commaDelimitedChildOrgGu?: string;
}

export class YearInfo {
  schoolYear?: string;
  yearGu?: string;
  extension?: string;
  fullYear?: string;
  fullYearCode?: string;
  fullYearVerbose?: string;
}

export class IntegratedActionItem {
  actionGU?: string;
  description?: string;
  viewGU?: string;
  primaryObjectGU?: string;
  isQueryBased: boolean = false;
  iconAlt?: string;
  iconSrc?: string;
}

export enum QBBOJoinType {
  Default = 0,
  Inner = 1,
  Outer = 2,
}

export class PreviewProperty {
  aggregateType: ColumnAggregateType = ColumnAggregateType.None;
  alias?: string;
  altCodeType: QBAltCodeType = QBAltCodeType.None;
  BOID?: string;
  break: QBBreakType = QBBreakType.None;
  displayType: QBDisplayType = QBDisplayType.Default;
  format?: string;
  graph: boolean = false;
  hide: boolean = false;
  ID?: string;
  labelOverride?: string;
  labelRow: number = 0;
  labelWidth?: string;
  labelWidthInInches: number = 0;
  order: number = 0;
  RELBOID?: string;
  srcElement?: string;
  srcElementOriginal?: string;
  textAlignment: QBPropertyTextAlignment = QBPropertyTextAlignment.Left;
  width?: string;
  widthInInches: number = 0;
}

export class ReportOutputLabel {
  xmlAttributeName?: string;
  label?: string;
  shortLabel?: string;
  shortLabelVert?: string;
  colLabel?: string;
  colLabelVert?: string;
  width?: string;
  order?: string;
}

export enum DateStatus {
  Active = 0,
  Inactive = 1,
  Highlighted = 2,
}

export class CalendarLegendItem {
  key?: string;
  description?: string;
  iconPath?: string;
  icon: GlyphIcon = GlyphIcon.None;
  colorIndex: number = 0;
}

export enum GlyphIcon {
  None = 0,
  Clock = 1,
  IDCard = 2,
  Bell = 3,
  Calendar = 4,
  Gavel = 5,
  GraduationCap = 6,
  Glass = 7,
  ThumbsDown = 8,
  ThumbsUp = 9,
  Ambulance = 10,
  Bus = 11,
  USD = 12,
  ArrowCircleDown = 13,
  ArrowDown = 14,
  Users = 15,
  Asterisk = 16,
  Child = 17,
  Danger = 18,
  Warning = 19,
  Failed = 20,
  Success = 21,
}

export enum MessageRole {
  System = 0,
  User = 1,
  Assistant = 2,
}

export enum UserRating {
  None = 0,
  Negative = 1,
  Positive = 2,
}

export class Trace {
  traceGU?: string;
  messageGU?: string;
  eventTime: DateTimeString = date.Empty;
  type?: string;
  json?: string;
}

export class ResponseCitationReference {
  ticketGU?: string;
  title?: string;
  text?: string;
  uri?: string;
  type: CitationDocumentType = CitationDocumentType.SupportDocument;
}

export class IControl {
  componentName?: string;
}

export class IActionAreaChild {
}

export class MenuDefinition {
  communityOpenViewID?: string;
  communityShareViewID?: string;
  showCriticalMenuItem: boolean = false;
  showLabel: boolean = false;
  controls: Array<IMenuChild> = [];
  items: Array<MenuItemDefinition> = [];
  ID?: string;
  alias?: string;
  disableLink: boolean = false;
  binding: DataBinding = new DataBinding;
  dataAllowWrap: boolean = false;
  labelAllowWrap: boolean = false;
  neverDisable: boolean = false;
  visible: boolean = false;
  label?: string;
  indicator: IndicatorInfo = new IndicatorInfo;
  linkOptions: LinkOptions = new LinkOptions;
}

export class ViewStatusDefinition {
  refreshButtonUpdateHTML: boolean = false;
  ID?: string;
  alias?: string;
  disableLink: boolean = false;
  binding: DataBinding = new DataBinding;
  dataAllowWrap: boolean = false;
  labelAllowWrap: boolean = false;
  neverDisable: boolean = false;
  visible: boolean = false;
  label?: string;
  indicator: IndicatorInfo = new IndicatorInfo;
  linkOptions: LinkOptions = new LinkOptions;
}

export class ITitleAreaChild {
}

export class PanelDefinition {
  readOnly: boolean = false;
  controls: Array<IViewChild> = [];
  ID?: string;
  alias?: string;
  disableLink: boolean = false;
  binding: DataBinding = new DataBinding;
  dataAllowWrap: boolean = false;
  labelAllowWrap: boolean = false;
  neverDisable: boolean = false;
  visible: boolean = false;
  label?: string;
  indicator: IndicatorInfo = new IndicatorInfo;
  linkOptions: LinkOptions = new LinkOptions;
}

export class TabDefinition {
  dataInvalidOnTabChange: boolean = false;
  helpID?: string;
  licenseKey?: string;
  lmsPage?: string;
  organizationType: OrganizationType = OrganizationType.Default;
  locale?: string;
  isSystem: boolean = false;
  useInAddWizard: boolean = false;
  readOnly: boolean = false;
  beforeEnter: boolean = false;
  beforeLeave: boolean = false;
  controls: Array<IViewChild> = [];
  ID?: string;
  alias?: string;
  disableLink: boolean = false;
  binding: DataBinding = new DataBinding;
  dataAllowWrap: boolean = false;
  labelAllowWrap: boolean = false;
  neverDisable: boolean = false;
  visible: boolean = false;
  label?: string;
  indicator: IndicatorInfo = new IndicatorInfo;
  linkOptions: LinkOptions = new LinkOptions;
}

export class IDataAreaChild {
}

export class SortPropertyDefinition {
  descending: boolean = false;
  sourceObject?: string;
  sourceElement?: string;
  relationPath: RelationPath = new RelationPath;
  ID?: string;
  alias?: string;
  disableLink: boolean = false;
  binding: DataBinding = new DataBinding;
  dataAllowWrap: boolean = false;
  labelAllowWrap: boolean = false;
  neverDisable: boolean = false;
  visible: boolean = false;
  label?: string;
  indicator: IndicatorInfo = new IndicatorInfo;
  linkOptions: LinkOptions = new LinkOptions;
}

export class RelationPath {
  relations: Array<Relation> = [];
}

export enum IndicatorType {
  None = 0,
  Success = 1,
  Note = 2,
  Filter = 3,
  Error = 4,
  Warning = 5,
  DetachWindow = 6,
}

export enum PropertyStyle {
  None = 0,
  StyleNotAvailable = 1,
  StyleLessEmphasis = 2,
  StyleEmphasis = 3,
  StyleMoreEmphasis = 4,
  StyleHighLight = 5,
  StyleWhite = 6,
  StyleBrightHighLight = 7,
  StyleError = 8,
  StyleWarning = 9,
  StyleLightBlue = 10,
  StyleCurrentDate = 11,
  StyleHide = 12,
  StyleGreen = 13,
  StyleOrange = 14,
  StyleViolet = 15,
  StyleRed = 16,
  StyleGreenLight = 17,
  StyleRedLight = 18,
  StyleClear = 19,
  StyleDataLessEmp = 20,
  StyleBrightHighLightWithBorder = 21,
  StyleNotAvailableEditable = 22,
  StyleOverdue = 23,
  StyleInProgress = 24,
  StyleComplete = 25,
  StyleGrayLight = 26,
}

export class Error {
  CODE?: string;
  row?: string;
  message?: string;
}

export class JSONClientAction {
  actionType?: string;
}

export class RevDataGroup {
  REV_ELEMENT: Array<RevElement> = [];
}

export class RevView {
  PRIMARY_OBJECT?: string;
  GUID?: string;
  REV_TAB: RevTab = new RevTab;
}

export class UserFilterObjCondition {
  BOID?: string;
  property?: string;
  conditionType?: string;
  conditionValue?: string;
  nestedFilterObj: UserFilterObj = new UserFilterObj;
  nestedSrcElement?: string;
  primaryBOID?: string;
}

export class STQueryJoinInfo {
  joinType: QBBOJoinType = QBBOJoinType.Default;
  from: BOPropertyReference = new BOPropertyReference;
  toProperty: BOPropertyReference = new BOPropertyReference;
  conditionContainer: STQueryConditionContainer = new STQueryConditionContainer;
}

export enum QBConditionContainerType {
  And = 0,
  Or = 1,
  Unknown = 2,
}

export class STQueryCondition {
  property: BOPropertyReference = new BOPropertyReference;
  not: boolean = false;
  conditionType: ConditionType = ConditionType.Unknown;
  value?: string;
  object: BOPropertyReference = new BOPropertyReference;
  parameter: STQueryParameterInfo = new STQueryParameterInfo;
  query: STQuery = new STQuery;
}

export class BOPropertyReference {
  alias?: string;
  srcElement?: string;
}

export enum QBSortType {
  Ascending = 0,
  Descending = 1,
}

export enum QBDisplayType {
  Default = 0,
  Both = 1,
  Description = 2,
  Code = 3,
}

export enum QBAltCodeType {
  None = 0,
  SIS = 1,
  State = 2,
  Alt3 = 3,
  SIF = 4,
  EdFi = 5,
  Federal = 6,
}

export enum ColumnAggregateType {
  None = 0,
  Sum = 1,
  Count = 2,
  Min = 3,
  Max = 4,
  Avg = 5,
  CountIncludeNULL = 6,
}

export enum QBBreakType {
  None = 0,
  Group = 1,
  Page = 2,
}

export class StudentSectionData {
  studentName?: string;
  absenceCode?: string;
  date?: string;
}

export enum QBPropertyTextAlignment {
  Left = 0,
  Center = 1,
  Right = 2,
  Justify = 3,
}

export enum CitationDocumentType {
  SupportDocument = 0,
  Ticket = 1,
}

export class IMenuChild {
}

export class MenuItemDefinition {
  confirmationText?: string;
  menuType: ButtonType = ButtonType.NewContentNewWindow;
  image?: string;
  progressMessage?: string;
  showConfirmation: boolean = false;
  controls: Array<IMenuChild> = [];
  items: Array<MenuItemDefinition> = [];
  ID?: string;
  alias?: string;
  disableLink: boolean = false;
  binding: DataBinding = new DataBinding;
  dataAllowWrap: boolean = false;
  labelAllowWrap: boolean = false;
  neverDisable: boolean = false;
  visible: boolean = false;
  label?: string;
  indicator: IndicatorInfo = new IndicatorInfo;
  linkOptions: LinkOptions = new LinkOptions;
}

export class Relation {
  srcRelation?: string;
}

export class RevElement {
  SRC_ELEMENT?: string;
  SRC_OBJECT?: string;
  SRC_NAME?: string;
  value?: string;
}

export class RevTab {
  GUID?: string;
  REV_GRID: RevGrid = new RevGrid;
}

export enum ConditionType {
  Unknown = 0,
  Equal = 1,
  NotEqual = 2,
  Less = 3,
  Greater = 4,
  LessThanOrEqual = 5,
  GreaterThanOrEqual = 6,
  In = 7,
  StartsWith = 8,
  EndsWith = 9,
  Contains = 10,
  NestedSelect = 11,
  LessOrNULL = 12,
  GreaterOrNULL = 13,
  LessThanOrEqualOrNULL = 14,
  GreaterThanOrEqualOrNULL = 15,
}

export class STQueryParameterInfo {
  name?: string;
  label?: string;
}

export enum ButtonType {
  NewContentNewWindow = 0,
  NewContentNewWindowNoResize = 1,
  NewContentNewWindowMaximize = 2,
  NewContentSameWindow = 3,
  SubmitDataAndReturnData = 4,
}

export class RevGrid {
  GUID?: string;
  PRIMARY_OBJECT?: string;
  BEFORE_READ?: string;
  GROUP_PROPERTY_VALUE_OVERRIDE?: string;
  SCROLL_FIELDS: RevScrollFields = new RevScrollFields;
  IDENTITY: RevIdentity = new RevIdentity;
  GROUP_FIELDS: RevGroupFields = new RevGroupFields;
  REV_COLUMNS: RevColumns = new RevColumns;
  FILTER_VALUES: RevFilterValues = new RevFilterValues;
  ROWS: RevRows = new RevRows;
}

export class RevScrollFields {
  REV_ELEMENT: Array<RevElement> = [];
}

export class RevIdentity {
  REV_ELEMENT: RevElement = new RevElement;
}

export class RevGroupFields {
  REV_ELEMENT: Array<RevElement> = [];
}

export class RevColumns {
  REV_ELEMENT: Array<RevElement> = [];
}

export class RevFilterValues {
  VALUES: Array<RevValues> = [];
}

export class RevRows {
  ROW: Array<RevRow> = [];
}

export class RevValues {
  SRC_NAME?: string;
  V: Array<RevValue> = [];
}

export class RevRow {
  REV_ELEMENT: Array<RevElement> = [];
}

export class RevValue {
  ID?: string;
  text?: string;
}
